import { ReadonlyMat4 } from 'gl-matrix';
import { Grid } from './Grid';
import { RotatedBoundingBox } from './RotatedBoundingBox';
import { VertexArrayObject } from '~/engine/core/utils/VertexArrayObject';

/**
 * {@link EnvironmentObject EnvironmentObject} is an object, which may be stored within {@link Environment}.\
 * These objects have some visual representation in PatientSpace.\
 * Most of these allocate some WebGL related data.\
 * They also have a {@link Grid grid} that defines their spatial properties, including transformations.
 * As examples, Images, StructureSets and Doses are all instances of {@link EnvironmentObject EnvironmentObject}.
 */
export abstract class EnvironmentObject {
    protected constructor() {}

    public abstract get grid(): Grid;

    get boundingBox(): RotatedBoundingBox {
        return this.grid.toRotatedBoundingBox();
    }

    public abstract delete(): void;

    /**
     * Method to calculate the intersection between this environment object's grid and a projection plane.\
     */
    public crossSection(
        toProjection: ReadonlyMat4
    ): VertexArrayObject | undefined {
        return this.grid.crossSection(toProjection);
    }
}

export type EnvironmentObjectClass<T extends EnvironmentObject> = new (
    ...args: never[]
) => T;
